import { Card, CardContent, Skeleton } from '@yeshuman/sdk'
"use client"


export function CandidateCardSkeleton() {
  return (
    <Card className="hover:shadow-md transition-shadow flex flex-col h-full">
      <CardContent className="flex flex-col flex-1 min-h-0">
        <div className="flex flex-col flex-1 min-h-0">
          <div className="flex-1 space-y-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-6 w-8 rounded-md shrink-0" />
              <Skeleton className="size-10 rounded-full shrink-0" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-5 w-32" />
                <div className="flex items-center gap-2 flex-wrap">
                  <Skeleton className="h-5 w-20 rounded-md" />
                  <Skeleton className="h-5 w-24 rounded-md" />
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-4">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-16" />
              </div>

              <Skeleton className="h-16 w-full rounded-md" />
            </div>
          </div>
          <div className="pt-4 mt-auto border-t">
            <Skeleton className="h-9 w-full rounded-md" />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
